import React, { useState } from "react";
import axios from "axios";
import { Button, Spinner, Title3 } from "@fluentui/react-components";
const DocumentAnalysis = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (!file) {
            setMessage("Please upload a document.");
            return;
        }

        // Validate file type for Word documents
        const allowedExtensions = ["doc", "docx"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            setMessage("Invalid file type. Please upload a Word document (.doc or .docx).");
            setSelectedFile(null);
            return;
        }

        setSelectedFile(file);
        setMessage("");
    };

    const handleUploadAndSubmit = async (apiUrl, contentType) => {
        if (!selectedFile) {
            setMessage("Please upload a document to analyze.");
            return;
        }
        setLoading(true);
        setMessage("");
        const formData = new FormData();
        formData.append("file", selectedFile);
        try {
            const response = await axios.post(apiUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200 && response.data) {
                setMessage(`${contentType} appended to Word document successfully!`);
                appendContentToWord(response.data, contentType); // Append the analyzed content to Word
                //setSelectedFile(null);
            } else {
                setMessage(`Error: Empty or invalid API response for ${contentType}.`);
            }
        } catch (error) {
            console.error(error);
            setMessage(`Error: Unable to process the document for ${contentType}.`);
        } finally {
            setLoading(false);
        }
    };



    const handleTOAFileUpload = async (apiUrl) => {
        if (!selectedFile) {
            setMessage("Please upload a document to analyze.");
            return;
        }

        setLoading(true);
        setMessage("");
        const formData = new FormData();
        formData.append("document", selectedFile);

        try {
            const response = await axios.post(apiUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log(response, 'response', response.data)
            if (response.status === 200 && response.data) {
                console.log("here")
                setMessage("Table of Authorities appended to Word document successfully!");
                appendContentToWordTOA((response.data)); // Append the TOA content to Word
                //setSelectedFile(null);
            } else {
                setMessage("Error: Empty or invalid API response for Table of Authorities.");
            }
        } catch (error) {
            console.error(error);
            setMessage("Error: Unable to process the document for Table of Authorities.");
        } finally {
            setLoading(false);
        }
    };

    // Function to append the Table of Authorities content to the Word document
    const appendContentToWordTOA = async (responseData) => {
        try {
            await Word.run(async (context) => {
                const selection = context.document.getSelection();

                let toaHtml = `
        <h1 style="text-align:center; font-weight:bold;">Table Of Authorities</h1>
      `;

                const formatAuthority = (text) => {
                    if (!text) return "";

                    const [authority, ...rest] = text.split(",");
                    const citation = rest.join(","); // join back in case there are more commas
                    return `<b><i>${authority.trim()}</i></b>${citation ? `,${citation}` : ""}`;
                };

                const buildTableRow = (left, right) => `
        <tr style="border:1px solid #ffffff;">
          <td style="
            padding:2px 8px 2px 0;
            border:1px solid #ffffff;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            width:90%;
          ">${formatAuthority(left)}</td>
          <td style="
            padding:2px 0 2px 8px;
            border:1px solid #ffffff;
            white-space:nowrap;
            text-align:right;
            width:10%;
          ">${right}</td>
        </tr>
      `;

                const addSection = (title, items, formatFn) => {
                    if (!items?.length) return;

                    toaHtml += `
          <h2 style="text-align:center; font-weight:bold; margin-top:14px;">${title}</h2>
          <table style="
            width:100%;
            border-collapse:collapse;
            border:1px solid #ffffff;
          ">
        `;

                    items.forEach(item => {
                        const [left, right] = formatFn(item);
                        toaHtml += buildTableRow(left, right);
                    });

                    toaHtml += `</table>`;
                };

                // Add sections
                addSection("Authorities", responseData?.Authorities || [], item => [
                    `${item.caseName ?? ""}, ${item.citation ?? ""}`,
                    item.page ?? ""
                ]);

                addSection("Other Authorities", responseData?.otherAuthorities || [], item => [
                    `${item.caseName ?? ""}, ${item.citation ?? ""}`,
                    item.page ?? ""
                ]);

                addSection("FEDERAL RULES", responseData?.Rules || [], item => [
                    item.citation ?? "",
                    item.page ?? ""
                ]);

                addSection("STATUTES", responseData?.Statutes || [], item => [
                    item.citation ?? "",
                    item.page ?? ""
                ]);

                // Insert into document selection
                selection.insertHtml(toaHtml, Word.InsertLocation.end);
                await context.sync();

                console.log("✅ TOA inserted with bold-italic authority names and white borders");
            });
        } catch (error) {
            console.error("❌ Error inserting TOA:", error);
            setMessage?.("❌ Failed to insert Table of Authorities.");
        }
    };

    const moveToHeading1 = async () => {
        try {
            await Word.run(async (context) => {
                const body = context.document.body;
                const searchResults = body.search("INTRODUCTION", { matchCase: false });

                context.load(searchResults, "text, range");
                await context.sync();

                if (searchResults.items.length > 0) {
                    const firstResult = searchResults.items[0];
                    firstResult.insertText("This is the inserted text.\n", "before");

                }

                await context.sync();
            });
        }
        catch (error) {
            console.error("Error moving cursor to Heading 1:", error);
        }
        // };


        return <div>Move Cursor to Heading 1 Example</div>;
    };

    const appendContentToWord = async (responseData, contentType) => {
        const items = [];
        let foundConclusion = false;
        // Process content based on the content type (TOC or TOA)
        for (const page of responseData) {
            if (page.pageNumber !== 0) {
                // Handle TOC
                for (const item of page.content) {
                    if (item.anchor && item.text?.length > 2) {
                        console.log(item.text);
                        items.push({
                            text: item.text || "",
                            pageNumber: page.pageNumber,
                        });
                        // Check if the text equals "CONCLUSION"
                        if (item.text.includes("CONCLUSION")) {
                            console.log("Found");
                            foundConclusion = true;
                            break; // Exit inner loop
                        }
                    }
                }
                if (foundConclusion) {
                    break; // Exit outer loop
                }
            }
        }

        try {

            await Word.run(async (context) => {
                const body = context.document.body;

                const findPageNumber = (keyword) => {
                    const result = items.find((item) => item.text.includes(keyword));
                    return result ? result.pageNumber : "0";
                };

                //let ritems = items.reverse();
                //console.log(ritems);
                let pagediff = (findPageNumber("INTRODUCTION") - 1);


                let tochtml = `<table class="toc">`;
                // Insert each item with proper styles
                items.forEach(item => {
                    // Validate item structure
                    if (!item.text || !item.pageNumber) {
                        console.error("Invalid item structure:", item);
                        return;
                    }

                    // Regular expressions to match specific patterns
                    const romanNumeralRegex = /^(I{1,3}|IV|V|VI{0,3}|X|XL)\.\s/;
                    const capitalAlphabetRegex = /^[A-Z]\.\s/;
                    const smallAlphabetRegex = /^[a-z]\.\s/;
                    //const numberRegex = /^[0-9]+\.\s/; 
                    const numberRegex = /^[0-9]{1}\.\s/;

                    let leftIndent = 0;
                    let space = "";

                    // Determine the left indent based on the text pattern
                    if (romanNumeralRegex.test(item.text)) {
                        console.log("Roman Num");
                        space = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                        leftIndent = 40;
                    } else if (capitalAlphabetRegex.test(item.text)) {
                        console.log("Capital Alpha");
                        space = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                        leftIndent = 60;
                    } else if (numberRegex.test(item.text)) {
                        space = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                        console.log("Num");
                        leftIndent = 80;
                    } else if (smallAlphabetRegex.test(item.text)) {
                        space = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                        console.log("Small");
                        leftIndent = 100;
                    } else {
                        // Skip items that don't match the required patterns
                        console.warn("Skipping item with unsupported text format:", item.text);
                        return;
                    }
                    //if(item.pageNumber-pagediff > 0){
                    tochtml += `<tr><td>${space}`;
                    console.log(item.text);
                    // Remove leading patterns (Roman numerals, capital letters, numbers, or special characters)
                    const cleanedText = item.text.replace(/^(I{1,3}|IV|V|VI{0,3}|X|XL|L|C|D|M|[A-Z]|[0-9]+)\.\s*/, '').trim();

                    // Convert cleaned text into a slug for the anchor's href
                    const anchorHref = cleanedText.replace(/\s+/g, '-').toLowerCase();

                    // Construct the text with 20 dots, page number, and anchor tag
                    const formattedText = `${item.text} `;
                    //${(item.pageNumber-pagediff)}
                    const anchorTag = `<a href="#${anchorHref}" style="color: blue;">${formattedText}.......................................</a>`;
                    tochtml += `<a href="#_bookmark4" style="color: blue;">${formattedText}</a></td>`;
                    tochtml += `<td>${(item.pageNumber - pagediff)}</td></tr>`;
                    //}

                });
                tochtml += `</table>`;
                // Insert a title for the section
                console.log(tochtml);
                const searchResults = body.search("INTRODUCTION", { matchCase: false });

                context.load(searchResults, "text, range");
                await context.sync();

                if (searchResults.items.length > 0) {
                    const firstResult = searchResults.items[0];
                    firstResult.insertHtml('<h1 style="text-align:center; font-weight:bold;">Table Of Contents</h1>', "before");
                    firstResult.insertHtml(tochtml, "before");

                    // const ss = body.insertHtml(tochtml, Word.InsertLocation.start);

                }

                await context.sync();

                //const ss = body.insertHtml(tochtml, Word.InsertLocation.start);
                // Insert a title for the section
                //  const title = body.insertParagraph(contentType, Word.InsertLocation.start);
                //  title.font.set({ bold: true, size: 14 });
                //  title.spaceAfter = 10;
                //  title.alignment = "Centered";

                await context.sync();
                console.log(`${contentType} inserted successfully with styles!`);
            });

        } catch (error) {
            console.error(`Error appending ${contentType} to Word document:`, error);
            setMessage(`Failed to append ${contentType}.`);
        }
    };



    return (
        <div style={{ marginTop: "10px", textAlign: "center", position: "relative" }}>
            
            <div style={{ marginBottom: "10px" }}>
                <label htmlFor="fileUpload">Our AI product transforms one of the most tedious aspects of brief-writing: creating a Table of Authorities. Traditionally, attorneys spent hours combing through citations to compile and format this critical section. With our technology, the entire process now takes seconds.</label>
            </div>
            <div style={{ position: "relative", display: "inline-block", marginBottom: "10px" }}>
                <input
                    type="file"
                    id="fileUpload"
                    onChange={handleFileUpload}
                    required
                    disabled={loading}
                    style={{ padding: "5px" }}
                />
                {loading && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1,
                            background: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            padding: "10px",
                        }}
                    >
                        <Spinner size="medium" />
                    </div>
                )}
            </div>
            {/* <Button
                onClick={() => handleUploadAndSubmit("http://localhost:8080/api/extract-toc", "Table of Contents")}
                appearance="primary"
                disabled={loading}
                style={{ marginRight: "10px" }}
            >
                Generate TOC
            </Button> */}
            {/* <Button
                onClick={() => appendContentToWord("Table of Contents")}
                appearance="primary"
                disabled={loading}
                style={{ marginRight: "10px" }}
            >
                Generate TOC
            </Button> */}
            {/* <Button
                onClick={moveToHeading1}
                appearance="primary"
                disabled={loading}
                style={{ marginRight: "10px" }}
            >
                Move to page
            </Button> */}
            <Button
                onClick={() => handleTOAFileUpload("https://mensreabackend.openteqdev.com/generateTOA", "Table of Authorities")}
                appearance="primary"
                disabled={loading}
            >
                Generate TOA
            </Button>
            {/* <Button
                onClick={() => appendContentToWordTOA( "Table of Authorities")}
                appearance="primary"
                disabled={loading}
            >
                Generate TOA
            </Button> */}

            <div style={{ marginTop: "10px", color: message.includes("successfully") ? "green" : "red" }}>
                {message}
            </div>
               <div style={{ marginBottom: "10px" }}>
                <label htmlFor="fileUpload">
The system automatically scans a legal brief and instantly generates a complete, fully formatted Table of Authorities—including citations from both the main body and the footnotes. As the brief evolves, attorneys can update the Table of Authorities in just seconds, eliminating manual re-checks, formatting hassles, and version-control errors.
The result: attorneys save hours of non-billable time, reduce the risk of costly mistakes, and focus their energy on legal strategy rather than administrative work.</label>
            </div>
        </div>
    );
};

export default DocumentAnalysis;

